module.exports = __webpack_public_path__ + "img/wool_tab.bf23211.webp";